import { icon } from "@fortawesome/fontawesome-svg-core";

export const SvgIcon = ({ name, isActive }) => {
  const iconColor = isActive ? "#0075ff" : "white";

  const icons = {
    home: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
        className="hover-svg"
      >
        <g clipPath="url(#clip0_1061_1820)">
          <path
            d="M8.16289 3.49384C8.11927 3.45212 8.06124 3.42883 8.00088 3.42883C7.94052 3.42883 7.88248 3.45212 7.83887 3.49384L2.44531 8.64628C2.42241 8.6682 2.40418 8.69453 2.39175 8.72368C2.37931 8.75284 2.37291 8.78421 2.37295 8.81591L2.37207 13.6517C2.37207 13.9003 2.47084 14.1387 2.64666 14.3146C2.82247 14.4904 3.06093 14.5892 3.30957 14.5892H6.125C6.24932 14.5892 6.36855 14.5398 6.45645 14.4519C6.54436 14.364 6.59375 14.2447 6.59375 14.1204V10.136C6.59375 10.0739 6.61844 10.0143 6.6624 9.9703C6.70635 9.92635 6.76596 9.90165 6.82812 9.90165H9.17187C9.23403 9.90165 9.29365 9.92635 9.3376 9.9703C9.38155 10.0143 9.40625 10.0739 9.40625 10.136V14.1204C9.40625 14.2447 9.45563 14.364 9.54354 14.4519C9.63145 14.5398 9.75068 14.5892 9.875 14.5892H12.6893C12.9379 14.5892 13.1764 14.4904 13.3522 14.3146C13.528 14.1387 13.6268 13.9003 13.6268 13.6517V8.81591C13.6268 8.78421 13.6204 8.75284 13.608 8.72368C13.5955 8.69453 13.5773 8.6682 13.5544 8.64628L8.16289 3.49384Z"
            fill={iconColor}
            className="path-1"
          />
          <path
            d="M14.8825 7.68005L12.6911 5.58357V2.40222C12.6911 2.2779 12.6417 2.15867 12.5538 2.07077C12.4659 1.98286 12.3467 1.93347 12.2223 1.93347H10.8161C10.6918 1.93347 10.5725 1.98286 10.4846 2.07077C10.3967 2.15867 10.3473 2.2779 10.3473 2.40222V3.33972L8.65047 1.71726C8.49168 1.55671 8.25555 1.46472 8.00037 1.46472C7.74608 1.46472 7.51053 1.55671 7.35174 1.71755L1.1203 7.67947C0.938073 7.85525 0.915221 8.14441 1.08104 8.33484C1.12268 8.38291 1.17367 8.422 1.23089 8.44973C1.28812 8.47747 1.3504 8.49327 1.41392 8.49618C1.47745 8.49908 1.54091 8.48903 1.60043 8.46663C1.65995 8.44423 1.71429 8.40996 1.76014 8.36589L7.83924 2.55691C7.88286 2.51518 7.94089 2.4919 8.00125 2.4919C8.06161 2.4919 8.11965 2.51518 8.16327 2.55691L14.2429 8.36589C14.3325 8.45178 14.4525 8.49865 14.5765 8.49623C14.7006 8.49381 14.8186 8.44231 14.9048 8.353C15.0846 8.16667 15.0697 7.85906 14.8825 7.68005Z"
            fill={iconColor}
            className="path-2"
          />
        </g>
        <defs>
          <clipPath id="clip0_1061_1820">
            <rect
              width="15"
              height="15"
              fill="white"
              transform="translate(0.5 0.526367)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    resume: (
      <svg
        width="15"
        height="11"
        viewBox="0 0 15 11"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
        className="hover-svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.89968 9.82335C9.15472 10.0784 9.56826 10.0784 9.82331 9.82335L14.1775 5.46916C14.4325 5.21409 14.4325 4.80062 14.1775 4.54555L9.82331 0.191386C9.56826 -0.0636806 9.15472 -0.0636806 8.89968 0.191386C8.64462 0.446453 8.64462 0.859926 8.89968 1.11499L12.1389 4.35423L5.00732 4.35423C4.38616 4.35423 3.43982 4.16248 2.66757 3.60645C1.92866 3.07446 1.30628 2.18202 1.30628 0.65319C1.30628 0.29249 1.01385 6.48499e-05 0.653154 6.48499e-05C0.292456 6.48499e-05 2.86102e-05 0.29249 2.86102e-05 0.65319C2.86102e-05 2.60769 0.829062 3.89234 1.90437 4.6666C2.94632 5.41682 4.17707 5.66048 5.00732 5.66048L12.1389 5.66048L8.89968 8.8997C8.64462 9.15475 8.64462 9.5683 8.89968 9.82335Z"
          fill={iconColor}
          className="path-1"
        />
      </svg>
    ),
    ranking: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill={iconColor}
      >
        <path
          d="M8 7.40137L5.5 2.40137H3L5.81613 8.31524M8 7.40137L10.5 2.40137H13L10.1839 8.31524M8 7.40137C8.84 7.40137 9.6155 7.75355 10.1839 8.31524M8 7.40137C7.16 7.40137 6.38449 7.75355 5.81613 8.31524M5.81613 8.31524C5.23862 8.88593 4.875 9.67287 4.875 10.5264C4.875 12.2522 6.27411 13.6514 8 13.6514C9.72587 13.6514 11.125 12.2522 11.125 10.5264C11.125 9.67287 10.7614 8.88593 10.1839 8.31524"
          stroke="white"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    ),
    reward: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8 4.90137V13.0264M8 4.90137H5.79018C5.46457 4.90137 5.15231 4.76967 4.92208 4.53525C4.69184 4.30083 4.5625 3.98289 4.5625 3.65137C4.5625 3.31985 4.69184 3.0019 4.92208 2.76749C5.15231 2.53306 5.46457 2.40137 5.79018 2.40137C7.50894 2.40137 8 4.90137 8 4.90137ZM8 4.90137H10.2098C10.5354 4.90137 10.8477 4.76967 11.0779 4.53525C11.3081 4.30083 11.4375 3.98289 11.4375 3.65137C11.4375 3.31985 11.3081 3.0019 11.0779 2.76749C10.8477 2.53306 10.5354 2.40137 10.2098 2.40137C8.49106 2.40137 8 4.90137 8 4.90137ZM3.625 8.02637H12.375V11.6514C12.375 12.3514 12.375 12.7015 12.2387 12.9689C12.1189 13.2041 11.9277 13.3953 11.6925 13.5151C11.4251 13.6514 11.0751 13.6514 10.375 13.6514H5.625C4.92493 13.6514 4.5749 13.6514 4.30751 13.5151C4.07231 13.3953 3.88108 13.2041 3.76124 12.9689C3.625 12.7015 3.625 12.3514 3.625 11.6514V8.02637ZM3.375 8.02637H12.625C12.9751 8.02637 13.1501 8.02637 13.2838 7.95824C13.4014 7.8983 13.4969 7.80274 13.5569 7.68512C13.625 7.55143 13.625 7.37643 13.625 7.02637V5.90137C13.625 5.55134 13.625 5.37632 13.5569 5.24262C13.4969 5.12502 13.4014 5.02941 13.2838 4.96949C13.1501 4.90137 12.9751 4.90137 12.625 4.90137H3.375C3.02497 4.90137 2.84995 4.90137 2.71626 4.96949C2.59866 5.02941 2.50304 5.12502 2.44312 5.24262C2.375 5.37632 2.375 5.55134 2.375 5.90137V7.02637C2.375 7.37643 2.375 7.55143 2.44312 7.68512C2.50304 7.80274 2.59866 7.8983 2.71626 7.95824C2.84995 8.02637 3.02497 8.02637 3.375 8.02637Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={iconColor}
        />
      </svg>
    ),
    finance: (
      <svg
        fill={iconColor}
        width="14px"
        height="14px"
        viewBox="0 0 50 50"
        version="1.2"
        baseProfile="tiny"
        xmlns="http://www.w3.org/2000/svg"
        overflow="inherit"
      >
        <path d="M43 12h-43v26h50v-26h-7zm5 19.271c-2.328.643-4.086 2.399-4.729 4.729h-36.542c-.644-2.328-2.4-4.086-4.729-4.729v-12.542c2.329-.644 4.085-2.4 4.729-4.729h36.565c.672 2.257 2.449 4.034 4.706 4.706v12.565zm-20.884-4.216c-.23-.14-.116-.269-1.116-.388v2.897l.548-.102c.742-.26 1.114-.745 1.114-1.451 0-.409-.183-.731-.546-.956zm-4.501-4.727c0 .445.203.78.607 1 .155.087.416.184.777.289v-2.741c-.294.069-.552.173-.769.315-.41.272-.615.652-.615 1.137zm2.385-7.328c-4.971 0-9 4.478-9 10 0 5.521 4.029 10 9 10s9-4.479 9-10c0-5.522-4.029-10-9-10zm3.854 15.654c-.679.58-1.854.935-2.854 1.069v1.277h-2v-1.3c-1.044-.142-1.909-.3-2.588-.835-.942-.742-1.412-1.865-1.412-2.865h2.488c.081 0 .239.801.475 1.084.245.291.593.325 1.037.448v-3.405c-1.217-.281-2.065-.584-2.536-.91-.841-.575-1.261-1.476-1.261-2.7 0-1.117.411-2.045 1.234-2.784.628-.565 1.484-.912 2.563-1.046v-1.687h2v1.74c1 .149 1.676.613 2.3 1.076.939.697 1.6 1.184 1.645 3.184h-2.506c-.047-1-.549-1.432-1.172-1.748-.033-.016-.267-.193-.267-.207v3.143l.902.174c.959.226 1.846.528 2.324.905.744.588 1.032 1.437 1.032 2.547.002 1.14-.524 2.086-1.404 2.84z" />
      </svg>
    ),
    trackUser: (
      <svg
        fill={iconColor}
        width="14px"
        height="14px"
        viewBox="0 0 14 14"
        role="img"
        focusable="false"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m 3.1873844,7.8426863 c -0.11145,-0.134289 -0.0612,-0.317282 0.11063,-0.402952 0.20079,-0.100105 1.4089502,-1.670687 1.36775,-1.778049 -0.0184,-0.04792 0.0151,-0.135607 0.0743,-0.194867 0.20933,-0.20933 0.49517,-0.09009 0.49517,0.206556 0,0.17839 0.44583,1.074742 0.53456,1.074742 0.0324,0 0.56602,-0.632511 1.18586,-1.405581 l 1.12697,-1.405581 -0.1736,-0.140083 -0.1736,-0.140084 0.38699,-0.0335 c 0.21285,-0.01843 0.39536,-0.0264 0.40559,-0.01771 0.0494,0.04196 0.0921,0.695179 0.0454,0.695179 -0.0295,0 -0.10257,-0.0443 -0.16239,-0.09844 -0.0988,-0.08942 -0.21401,0.03308 -1.25729,1.336984 -0.63169,0.789484 -1.1616,1.503819 -1.17757,1.587412 -0.0344,0.180123 -0.29981,0.269659 -0.44417,0.149856 -0.0541,-0.0449 -0.0984,-0.168024 -0.0984,-0.273617 0,-0.174499 -0.44072,-1.159885 -0.4942,-1.104957 -0.0125,0.01282 -0.30668,0.389544 -0.65376,0.837158 -0.38152,0.492024 -0.61642,0.852 -0.59403,0.910336 0.0902,0.235137 -0.33486,0.401366 -0.5043,0.197203 z m 6.2226116,-5.40128 c -1.92114,-1.92163005 -5.047381,-1.92163005 -6.968813,0 -1.921577,1.9211399 -1.921577,5.0475299 0,6.96881 1.855519,1.8554897 4.834556,1.9186397 6.767084,0.19043 l 0.390671,0.39082 c -0.09728,0.2489997 -0.04628,0.5424197 0.154807,0.7435297 l 2.061471,2.06145 c 0.270991,0.27116 0.710564,0.27116 0.98141,0 0.271165,-0.27085 0.271165,-0.71031 0,-0.98159 L 10.735329,9.7538263 c -0.201262,-0.20141 -0.494797,-0.25238 -0.743827,-0.15496 l -0.39067,-0.39081 c 1.728528,-1.93241 1.6648,-4.91145 -0.190836,-6.76665 z m -6.379938,6.38008 c -1.596673,-1.59649 -1.596673,-4.19476 0,-5.7914401 1.596528,-1.59667 4.19471,-1.59667 5.791354,0 1.596674,1.59668 1.596674,4.1949201 0,5.7914401 -1.596644,1.5964997 -4.194826,1.5964997 -5.791354,0 z" />
      </svg>
    ),
    users: (
      <svg
        width="14px"
        height="14px"
        viewBox="0 0 15 15"
        fill={iconColor}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.5 0C3.56717 0 2 1.56567 2 3.49804C2 5.43041 3.56717 6.99609 5.5 6.99609C7.43283 6.99609 9 5.43041 9 3.49804C9 1.56567 7.43283 0 5.5 0Z"
          fill={iconColor}
        />
        <path
          d="M3.5 8.99414C1.56711 8.99414 0 10.5605 0 12.4936V14.9909H11V12.4936C11 10.5605 9.43289 8.99414 7.5 8.99414H3.5Z"
          fill={iconColor}
        />
        <path
          d="M12.5 10H12V15H15V12.5C15 11.1193 13.8807 10 12.5 10Z"
          fill={iconColor}
        />
        <path
          d="M11.5 4C10.1193 4 9 5.11929 9 6.5C9 7.88071 10.1193 9 11.5 9C12.8807 9 14 7.88071 14 6.5C14 5.11929 12.8807 4 11.5 4Z"
          fill={iconColor}
        />
      </svg>
    ),
    signupLink: (
      <svg
        width="20px"
        height="20px"
        viewBox="0 0 16 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={iconColor}
          d="M14.9 1.1c-1.4-1.4-3.7-1.4-5.1 0l-4.4 4.3c-1.4 1.5-1.4 3.7 0 5.2 0.1 0.1 0.3 0.2 0.4 0.3l1.5-1.5c-0.1-0.1-0.3-0.2-0.4-0.3-0.6-0.6-0.6-1.6 0-2.2l4.4-4.4c0.6-0.6 1.6-0.6 2.2 0s0.6 1.6 0 2.2l-1.3 1.3c0.4 0.8 0.5 1.7 0.4 2.5l2.3-2.3c1.5-1.4 1.5-3.7 0-5.1z"
        ></path>
        <path
          fill={iconColor}
          d="M10.2 5.1l-1.5 1.5c0 0 0.3 0.2 0.4 0.3 0.6 0.6 0.6 1.6 0 2.2l-4.4 4.4c-0.6 0.6-1.6 0.6-2.2 0s-0.6-1.6 0-2.2l1.3-1.3c-0.4-0.8-0.1-1.3-0.4-2.5l-2.3 2.3c-1.4 1.4-1.4 3.7 0 5.1s3.7 1.4 5.1 0l4.4-4.4c1.4-1.4 1.4-3.7 0-5.1-0.2-0.1-0.4-0.3-0.4-0.3z"
        ></path>
      </svg>
    ),
    coupon: (
      <svg
        fill={iconColor}
        height="44px"
        width="44px"
        version="1.1"
        viewBox="0 0 40 40"
        enableBackground="new 0 0 40 40"
      >
        <g>
          <g>
            <g>
              <path
                d="M19.6,28.5L19.6,28.5c-0.1,0-0.3-0.1-0.4-0.1c-0.8-0.8-2.2-0.8-2.9,0c-0.2,0.2-0.5,0.2-0.7,0l-4-4
				c-0.2-0.2-0.2-0.5,0-0.7c0.8-0.8,0.8-2.1,0-2.9c-0.2-0.2-0.2-0.5,0-0.7l8.4-8.4c0.1-0.1,0.2-0.1,0.4-0.1l0,0
				c0.1,0,0.3,0.1,0.4,0.1c0.8,0.8,2.1,0.8,2.9,0c0.2-0.2,0.5-0.2,0.7,0l4,4c0.2,0.2,0.2,0.5,0,0.7c-0.8,0.8-0.8,2.1,0,2.9
				c0.2,0.2,0.2,0.5,0,0.7L20,28.4C19.9,28.4,19.7,28.5,19.6,28.5z M12.7,24l3.3,3.3c1-0.7,2.5-0.7,3.6,0l7.7-7.7
				c-0.8-1.1-0.8-2.5,0-3.6L24,12.7c-1,0.7-2.5,0.7-3.6,0l-7.7,7.7C13.4,21.5,13.4,22.9,12.7,24z"
              />
            </g>
            <g>
              <g>
                <path
                  d="M21,23.3c-0.2,0-0.4-0.1-0.5-0.4l-1.7-5.9c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3l1.7,5.9
					c0.1,0.3-0.1,0.5-0.3,0.6C21.1,23.3,21.1,23.3,21,23.3z"
                />
              </g>
              <g>
                <g>
                  <g>
                    <path d="M23,20.9c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S23.6,20.9,23,20.9z" />
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M17.4,20.8c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S17.9,20.8,17.4,20.8z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    ),
    dollar: (
      <svg
        fill={iconColor}
        width="24px"
        height="24px"
        viewBox="-5 0 19 19"
        xmlns="http://www.w3.org/2000/svg"
        className="cf-icon-svg w-5 h-5"
      >
        <path d="M8.699 11.907a3.005 3.005 0 0 1-1.503 2.578 4.903 4.903 0 0 1-1.651.663V16.3a1.03 1.03 0 1 1-2.059 0v-1.141l-.063-.011a5.199 5.199 0 0 1-1.064-.325 3.414 3.414 0 0 1-1.311-.962 1.029 1.029 0 1 1 1.556-1.347 1.39 1.39 0 0 0 .52.397l.002.001a3.367 3.367 0 0 0 .648.208h.002a4.964 4.964 0 0 0 .695.084 3.132 3.132 0 0 0 1.605-.445c.5-.325.564-.625.564-.851a1.005 1.005 0 0 0-.245-.65 2.06 2.06 0 0 0-.55-.44 2.705 2.705 0 0 0-.664-.24 3.107 3.107 0 0 0-.65-.066 6.046 6.046 0 0 1-1.008-.08 4.578 4.578 0 0 1-1.287-.415A3.708 3.708 0 0 1 1.02 9.04a3.115 3.115 0 0 1-.718-1.954 2.965 2.965 0 0 1 .321-1.333 3.407 3.407 0 0 1 1.253-1.335 4.872 4.872 0 0 1 1.611-.631V2.674a1.03 1.03 0 1 1 2.059 0v1.144l.063.014h.002a5.464 5.464 0 0 1 1.075.368 3.963 3.963 0 0 1 1.157.795A1.03 1.03 0 0 1 6.39 6.453a1.901 1.901 0 0 0-.549-.376 3.516 3.516 0 0 0-.669-.234l-.066-.014a3.183 3.183 0 0 0-.558-.093 3.062 3.062 0 0 0-1.572.422 1.102 1.102 0 0 0-.615.928 1.086 1.086 0 0 0 .256.654l.002.003a1.679 1.679 0 0 0 .537.43l.002.002a2.57 2.57 0 0 0 .703.225h.002a4.012 4.012 0 0 0 .668.053 5.165 5.165 0 0 1 1.087.112l.003.001a4.804 4.804 0 0 1 1.182.428l.004.002a4.115 4.115 0 0 1 1.138.906l.002.002a3.05 3.05 0 0 1 .753 2.003z" />
      </svg>
    ),
    settings: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M14.2563 4.05772C14.2226 3.99208 14.1738 3.93533 14.1139 3.8921C14.0541 3.84888 13.9849 3.82039 13.912 3.80897C13.8391 3.79755 13.7645 3.80351 13.6943 3.82638C13.6241 3.84924 13.5603 3.88835 13.5081 3.94054L11.7081 5.74171C11.6197 5.82879 11.5006 5.8776 11.3766 5.8776C11.2525 5.8776 11.1334 5.82879 11.0451 5.74171L10.267 4.96241C10.2234 4.91888 10.1889 4.8672 10.1653 4.81033C10.1418 4.75345 10.1296 4.69248 10.1296 4.63092C10.1296 4.56935 10.1418 4.50839 10.1653 4.45151C10.1889 4.39463 10.2234 4.34295 10.267 4.29942L12.0593 2.50675C12.1131 2.45302 12.1529 2.38704 12.1755 2.31449C12.1981 2.24193 12.2027 2.16498 12.1889 2.09026C12.1751 2.01554 12.1434 1.94528 12.0964 1.88555C12.0494 1.82582 11.9887 1.7784 11.9193 1.74737C10.5655 1.1421 8.87566 1.45792 7.81013 2.51554C6.90486 3.41437 6.63503 4.81886 7.07038 6.36895C7.09386 6.45162 7.09399 6.53916 7.07077 6.6219C7.04756 6.70463 7.00189 6.77932 6.93884 6.8377L2.0615 11.2923C1.87149 11.4629 1.71823 11.6704 1.61107 11.9022C1.5039 12.134 1.44508 12.3852 1.43819 12.6404C1.43129 12.8957 1.47647 13.1497 1.57098 13.3869C1.66548 13.6241 1.80732 13.8396 1.98784 14.0202C2.16836 14.2008 2.38379 14.3428 2.62097 14.4374C2.85816 14.532 3.11213 14.5773 3.36739 14.5705C3.62266 14.5637 3.87387 14.505 4.1057 14.3979C4.33753 14.2909 4.54511 14.1377 4.71579 13.9478L9.21814 9.05958C9.27568 8.99734 9.34911 8.95198 9.43052 8.92839C9.51194 8.90479 9.59824 8.90386 9.68015 8.92569C10.1215 9.04661 10.5767 9.10935 11.0342 9.11231C12.0128 9.11231 12.8715 8.79561 13.4908 8.18536C14.6378 7.05538 14.8127 5.13878 14.2563 4.05772ZM3.41472 13.627C3.22177 13.648 3.02704 13.6087 2.85741 13.5144C2.68777 13.42 2.55159 13.2754 2.46767 13.1004C2.38374 12.9254 2.3562 12.7286 2.38886 12.5373C2.42151 12.3459 2.51274 12.1695 2.64996 12.0322C2.78719 11.8949 2.96363 11.8036 3.15495 11.7709C3.34627 11.7382 3.54302 11.7657 3.71807 11.8495C3.89311 11.9334 4.03781 12.0695 4.13219 12.2391C4.22657 12.4087 4.26599 12.6034 4.24499 12.7964C4.2219 13.0087 4.12701 13.2068 3.97602 13.3578C3.82504 13.5088 3.62702 13.6038 3.41472 13.627Z"
          fill={iconColor}
        />
      </svg>
    ),

    sales: (
      <svg
        version="1.0"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        width="26px"
        height="26px"
        viewBox="0 0 64 64"
        enable-background="new 0 0 64 64"
      >
        <g>
          <polygon
            fill={iconColor}
            stroke="#000000"
            stroke-width="2"
            stroke-miterlimit="10"
            points="21.903,5 55,38.097 34.097,59 1,25.903 
		1,5 	"
          />
          <polyline
            fill={iconColor}
            stroke="#000000"
            stroke-width="2"
            stroke-miterlimit="10"
            points="29.903,5 63,38.097 42.097,59 	"
          />
          <circle
            fill={iconColor}
            stroke="#000000"
            stroke-width="2"
            stroke-miterlimit="10"
            cx="14"
            cy="18"
            r="5"
          />
        </g>
      </svg>
    ),

    sourceAquisition: (
      <svg
        width="26px"
        height="26px"
        viewBox="0 0 1024 1024"
        class="icon"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M748.6 612.8l52.6-50.8c-43.5-45.1-95.5-78.7-152.6-99.3 49.4-40.3 81.1-101.6 81.1-170.2 0-121-98.4-219.4-219.4-219.4s-219.4 98.4-219.4 219.4c0 69.1 32.1 130.8 82.1 171.1-153.7 56.6-263.6 204.5-263.6 377.7h73.1c0-181.5 147.7-329.1 329.1-329.1 90.2-0.1 174.4 35.7 237 100.6zM510.3 146.3c80.7 0 146.3 65.6 146.3 146.3S591 438.9 510.3 438.9 364 373.2 364 292.6s65.6-146.3 146.3-146.3zM692.7 679.2l160.9 160.9 58.9-219.8-219.8 58.9z m132.5 54.9l-26.5-26.5 36.3-9.7-9.8 36.2zM616.2 913.9L836 855 675.1 694.1l-58.9 219.8z m87.3-113.8l26.5 26.5-36.3 9.7 9.8-36.2z"
          fill={iconColor}
        />
      </svg>
    ),
    hamburger: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4 6h16M4 12h16m-16 6h16"
        />
      </svg>
    ),
    arrowLeft: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 19l-7-7 7-7"
        />
      </svg>
    ),
    tickMark: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <rect width="14" height="14" rx="7" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM9.94996 5.7174C10.1407 5.52671 10.1407 5.21748 9.94996 5.02676C9.75924 4.83604 9.45007 4.83604 9.25934 5.02676L6.24687 8.03919C6.18331 8.10274 6.08023 8.10274 6.01668 8.03919L4.74068 6.76317C4.54996 6.57245 4.24074 6.57245 4.05002 6.76317C3.8593 6.9539 3.8593 7.26313 4.05002 7.45386L5.32601 8.72988C5.771 9.17488 6.49255 9.17488 6.93755 8.72988L9.94996 5.7174Z"
          fill="#32BD9C"
        />
      </svg>
    ),
    sphere: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <g opacity="0.1">
          <rect width="14" height="14" rx="7" fill="white" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM9.94996 5.7174C10.1407 5.52671 10.1407 5.21748 9.94996 5.02676C9.75924 4.83604 9.45007 4.83604 9.25934 5.02676L6.24687 8.03919C6.18331 8.10274 6.08023 8.10274 6.01668 8.03919L4.74068 6.76317C4.54996 6.57245 4.24074 6.57245 4.05002 6.76317C3.8593 6.9539 3.8593 7.26313 4.05002 7.45386L5.32601 8.72988C5.771 9.17488 6.49255 9.17488 6.93755 8.72988L9.94996 5.7174Z"
            fill="#32BD9C"
          />
        </g>
      </svg>
    ),
    lessonLock: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="7"
        height="10"
        viewBox="0 0 7 10"
        fill="none"
      >
        <path
          d="M6.56203 4.37406H1.75V2.62406C1.75 1.65789 2.53383 0.87406 3.5 0.87406C4.46617 0.87406 5.25 1.65789 5.25 2.62406V3.06203H6.12406V2.62406C6.12406 1.17481 4.94925 0 3.5 0C2.05075 0 0.87594 1.17481 0.87594 2.62406V4.37406H0.43797C0.197368 4.37406 0 4.56955 0 4.81203V9.18609C0 9.42857 0.195489 9.62406 0.43797 9.62406H6.56203C6.80263 9.62406 7 9.42857 7 9.18609V4.81203C7 4.56955 6.80451 4.37406 6.56203 4.37406Z"
          fill="white"
        />
      </svg>
    ),

    vectorDown: (
      <svg
        width="12"
        height="8"
        viewBox="0 0 10 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="Vector"
          d="M0.203917 0.706388C-0.0678968 0.978209 -0.0678968 1.41896 0.203917 1.69077L3.60928 5.09272C4.15297 5.63593 5.03405 5.63572 5.57754 5.09231L8.98155 1.68827C9.25338 1.41645 9.25338 0.975703 8.98155 0.703876C8.70972 0.432041 8.269 0.432041 7.99716 0.703876L5.08368 3.61734C4.81187 3.88923 4.37112 3.88923 4.09931 3.61734L1.18829 0.706388C0.916479 0.434554 0.4758 0.434554 0.203917 0.706388Z"
          fill="white"
        />
      </svg>
    ),
    vectorRight: (
      <svg
        width="8"
        height="12"
        viewBox="0 0 5 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="Vector"
          d="M0.206388 9.38873C0.478209 9.66055 0.918958 9.66055 1.19077 9.38873L4.59272 5.98337C5.13593 5.43968 5.13572 4.5586 4.59231 4.01511L1.18827 0.611097C0.916452 0.33927 0.475703 0.33927 0.203876 0.611097C-0.0679586 0.882932 -0.0679586 1.32365 0.203876 1.59549L3.11734 4.50897C3.38923 4.78078 3.38923 5.22153 3.11734 5.49334L0.206388 8.40436C-0.0654461 8.67617 -0.0654461 9.11685 0.206388 9.38873Z"
          fill="white"
        />
      </svg>
    ),
    questionMark: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
      >
        <rect width="24" height="24" rx="12" fill="#202124" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM8.8 9.6C8.8 7.83269 10.2327 6.4 12 6.4H12.96C14.6389 6.4 16 7.76106 16 9.44V9.6C16 11.3673 14.5673 12.8 12.8 12.8V14.4H11.2V11.2H12.8C13.6836 11.2 14.4 10.4836 14.4 9.6V9.44C14.4 8.6447 13.7553 8 12.96 8H12C11.1164 8 10.4 8.71635 10.4 9.6H8.8ZM11.2 17.6V16H12.8V17.6H11.2Z"
          fill="white"
        />
      </svg>
    ),

    download: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 61 60"
        fill="none"
      >
        <path
          d="M31.5517 41.2653C31.1965 41.6537 30.6945 41.875 30.168 41.875C29.6415 41.875 29.1395 41.6537 28.7842 41.2653L18.7842 30.3277C18.0854 29.5635 18.1385 28.3775 18.9028 27.6787C19.6671 26.98 20.853 27.033 21.5518 27.7973L28.293 35.1705V7.5C28.293 6.46448 29.1325 5.625 30.168 5.625C31.2035 5.625 32.043 6.46448 32.043 7.5V35.1705L38.7842 27.7973C39.483 27.033 40.669 26.98 41.4332 27.6787C42.1975 28.3775 42.2505 29.5635 41.5517 30.3277L31.5517 41.2653Z"
          fill="#0075FF"
        />
        <path
          d="M9.54297 37.5C9.54297 36.4645 8.70352 35.625 7.66797 35.625C6.63245 35.625 5.79297 36.4645 5.79297 37.5V37.6373C5.79292 41.0563 5.79287 43.812 6.08427 45.9795C6.38682 48.2297 7.03404 50.1242 8.53885 51.629C10.0436 53.134 11.9383 53.7812 14.1886 54.0837C16.356 54.375 19.1118 54.375 22.5308 54.375H37.8052C41.2242 54.375 43.98 54.375 46.1475 54.0837C48.3977 53.7812 50.2922 53.134 51.7972 51.629C53.302 50.1242 53.9492 48.2297 54.2517 45.9795C54.543 43.812 54.543 41.0563 54.543 37.6373V37.5C54.543 36.4645 53.7035 35.625 52.668 35.625C51.6325 35.625 50.793 36.4645 50.793 37.5C50.793 41.0885 50.789 43.5913 50.5352 45.4798C50.2885 47.3143 49.8375 48.2855 49.1455 48.9775C48.4535 49.6695 47.4822 50.1205 45.6477 50.3673C43.7592 50.621 41.2565 50.625 37.668 50.625H22.668C19.0794 50.625 16.5766 50.621 14.6883 50.3673C12.8538 50.1205 11.8824 49.6695 11.1905 48.9775C10.4986 48.2855 10.0475 47.3143 9.80084 45.4798C9.54694 43.5913 9.54297 41.0885 9.54297 37.5Z"
          fill="#0075FF"
        />
      </svg>
    ),
    rewardLock: (
      <svg
        width="20"
        height="26"
        viewBox="0 0 46 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M41.9166 22.5H38.1666V15C38.1666 6.71625 31.4504 0 23.1666 0C14.8829 0 8.16663 6.71625 8.16663 15V22.5H4.41663C2.34381 22.5 0.666626 24.1772 0.666626 26.25V56.25C0.666626 58.3228 2.34381 60 4.41663 60H41.9166C43.9894 60 45.6666 58.3228 45.6666 56.25V26.25C45.6666 24.1772 43.9894 22.5 41.9166 22.5ZM23.1666 45C21.0938 45 19.4166 43.3228 19.4166 41.25C19.4166 39.1772 21.0938 37.5 23.1666 37.5C25.2394 37.5 26.9166 39.1772 26.9166 41.25C26.9166 43.3228 25.2394 45 23.1666 45ZM30.6666 22.5H15.6666V15C15.6666 10.8581 19.0247 7.5 23.1666 7.5C27.3085 7.5 30.6666 10.8581 30.6666 15V22.5Z"
          fill="#A0AEC0"
        />
      </svg>
    ),
    logout: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="16"
        height="16"
      >
        <path
          fill="white"
          d="M16 17v-3H9v-4h7V7l5 5-5 5M14 2a2 2 0 012 2v2h-2V4H5v16h9v-2h2v2a2 2 0 01-2 2H5a2 2 0 01-2-2V4a2 2 0 012-2h9z"
        />
      </svg>
    ),
    clock: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
      >
        <path
          d="M17.125 6.125L18.4375 4.8125"
          stroke="#0075FF"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M19.75 5.25L18 3.5"
          stroke="#0075FF"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M18.875 11.5938C18.875 15.9407 15.347 19.4688 11 19.4688C6.653 19.4688 3.125 15.9407 3.125 11.5938C3.125 7.24675 6.653 3.71875 11 3.71875C15.347 3.71875 18.875 7.24675 18.875 11.5938Z"
          stroke="#0075FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 7.21875V11.5938"
          stroke="#0075FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.375 1.53125H13.625"
          stroke="#0075FF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    login: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        className="w-5 h-5"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-9A2.25 2.25 0 002.25 5.25v13.5A2.25 2.25 0 004.5 21h9a2.25 2.25 0 002.25-2.25V15M12 9l3 3m0 0l-3 3m0-3h8.25"
        />
      </svg>
    ),
    signup: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        className="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13.5 7.5L15 9m0 0l-1.5 1.5M15 9H6m9 4.5L15 15m0 0l-1.5 1.5M15 15H6m7.5-9a2.25 2.25 0 00-2.25 2.25V12h4.5V8.25A2.25 2.25 0 0010.5 6m-6 6a3 3 0 00-3 3v4.5a3 3 0 003 3h12a3 3 0 003-3v-4.5a3 3 0 00-3-3"
        />
      </svg>
    ),
    cross: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clipRule="evenodd"
          d="M13.5356 12.65C13.78 12.8937 13.78 13.2938 13.5356 13.5375C13.2919 13.7813 12.8956 13.7813 12.6513 13.5375L10.0037 10.8875L7.33749 13.5562C7.09124 13.8 6.69252 13.8 6.44627 13.5562C6.20064 13.3062 6.20064 12.9063 6.44627 12.6625L9.11251 9.99374L6.465 7.35001C6.22062 7.10626 6.22062 6.70623 6.465 6.46248C6.70812 6.21873 7.10437 6.21873 7.34875 6.46248L9.99626 9.11247L12.6825 6.42502C12.9287 6.18127 13.3269 6.18127 13.5731 6.42502C13.8187 6.67502 13.8187 7.06873 13.5731 7.31873L10.8875 10.0063L13.5356 12.65ZM10 0C4.47688 0 0 4.475 0 10C0 15.525 4.47688 20 10 20C15.5231 20 20 15.525 20 10C20 4.475 15.5231 0 10 0Z"
          fill="#CE0500"
        />
      </svg>
    ),
    video: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill={iconColor}
        width="16px"
        height="16px"
      >
        <path d="M10 8.64v6.72c0 .39.4.63.75.44l5.55-3.36c.35-.21.35-.68 0-.88l-5.55-3.36a.5.5 0 00-.75.44zM12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0zm0 21.6c-5.29 0-9.6-4.31-9.6-9.6 0-5.29 4.31-9.6 9.6-9.6 5.29 0 9.6 4.31 9.6 9.6 0 5.29-4.31 9.6-9.6 9.6z" />
      </svg>
    ),
    section: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill={iconColor}
        viewBox="0 0 24 24"
        width="16px"
        height="16px"
      >
        <path d="M4 10.5c0 .83-.67 1.5-1.5 1.5S1 11.33 1 10.5 1.67 9 2.5 9 4 9.67 4 10.5zm0 6c0 .83-.67 1.5-1.5 1.5S1 17.33 1 16.5 1.67 15 2.5 15 4 15.67 4 16.5zM4 4.5C4 5.33 3.33 6 2.5 6S1 5.33 1 4.5 1.67 3 2.5 3 4 3.67 4 4.5zM8 11h14v-1H8v1zm0 6h14v-1H8v1zm0-13v1h14V4H8z" />
      </svg>
    ),
    quiz: (
      <svg
        width="16px"
        height="16px"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={iconColor}
          d="M14.6 0H3.4A1.417 1.417 0 0 0 2 1.43v15.14A1.417 1.417 0 0 0 3.4 18h11.2a1.417 1.417 0 0 0 1.4-1.43V1.43A1.417 1.417 0 0 0 14.6 0zM9 16a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm1-6.13V12a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1 2 2 0 1 0-2-2 1 1 0 0 1-2 0 4 4 0 1 1 5 3.87z"
        />
      </svg>
    ),
    module: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="16px"
        height="16px"
        fill={iconColor}
      >
        <rect x="3" y="3" width="8" height="8" rx="1" />
        <rect x="13" y="3" width="8" height="8" rx="1" />
        <rect x="3" y="13" width="8" height="8" rx="1" />
        <rect x="13" y="13" width="8" height="8" rx="1" />
      </svg>
    ),
    course: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill={iconColor}
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
        width="16"
        height="16"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4 19.5V6.5C4 5.12 5.12 4 6.5 4H17.5C18.88 4 20 5.12 20 6.5V19.5M4 19.5L12 15.5L20 19.5M4 19.5L12 23L20 19.5"
        />
      </svg>
    ),
    navItemVideo: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="12" fill="white" />
        <path
          d="M9.66602 7.91663V16.0833L16.0827 12L9.66602 7.91663Z"
          fill="#202124"
        />
      </svg>
    ),
    stats: (
      <svg
        fill={iconColor}
        width="18px"
        height="18px"
        viewBox="0 0 1900 1900"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M746.667 106.667H1173.33V1493.33H746.667V106.667ZM533.333 533.333H106.667V1493.33H533.333V533.333ZM1920 1706.67H0V1824H1920V1706.67ZM1813.33 746.667H1386.67V1493.33H1813.33V746.667Z" />
      </svg>
    ),

    AiTools: (
      <svg
        width="18px"
        height="18px"
        viewBox="0 0 512 512"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>ai</title>
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="icon"
            fill={iconColor}
            transform="translate(64.000000, 64.000000)"
          >
            <path
              d="M320,64 L320,320 L64,320 L64,64 L320,64 Z M171.749388,128 L146.817842,128 L99.4840387,256 L121.976629,256 L130.913039,230.977 L187.575039,230.977 L196.319607,256 L220.167172,256 L171.749388,128 Z M260.093778,128 L237.691519,128 L237.691519,256 L260.093778,256 L260.093778,128 Z M159.094727,149.47526 L181.409039,213.333 L137.135039,213.333 L159.094727,149.47526 Z M341.333333,256 L384,256 L384,298.666667 L341.333333,298.666667 L341.333333,256 Z M85.3333333,341.333333 L128,341.333333 L128,384 L85.3333333,384 L85.3333333,341.333333 Z M170.666667,341.333333 L213.333333,341.333333 L213.333333,384 L170.666667,384 L170.666667,341.333333 Z M85.3333333,0 L128,0 L128,42.6666667 L85.3333333,42.6666667 L85.3333333,0 Z M256,341.333333 L298.666667,341.333333 L298.666667,384 L256,384 L256,341.333333 Z M170.666667,0 L213.333333,0 L213.333333,42.6666667 L170.666667,42.6666667 L170.666667,0 Z M256,0 L298.666667,0 L298.666667,42.6666667 L256,42.6666667 L256,0 Z M341.333333,170.666667 L384,170.666667 L384,213.333333 L341.333333,213.333333 L341.333333,170.666667 Z M0,256 L42.6666667,256 L42.6666667,298.666667 L0,298.666667 L0,256 Z M341.333333,85.3333333 L384,85.3333333 L384,128 L341.333333,128 L341.333333,85.3333333 Z M0,170.666667 L42.6666667,170.666667 L42.6666667,213.333333 L0,213.333333 L0,170.666667 Z M0,85.3333333 L42.6666667,85.3333333 L42.6666667,128 L0,128 L0,85.3333333 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </svg>
    ),
    quizzSummaryArrowleft: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="5"
        height="11"
        viewBox="0 0 5 11"
        fill="none"
      >
        <path
          d="M4.79361 1.11127C4.52179 0.839452 4.08104 0.839452 3.80923 1.11127L0.407277 4.51663C-0.135933 5.06032 -0.135724 5.9414 0.407695 6.48489L3.81173 9.8889C4.08355 10.1607 4.5243 10.1607 4.79612 9.8889C5.06796 9.61707 5.06796 9.17635 4.79612 8.90451L1.88266 5.99103C1.61077 5.71922 1.61077 5.27847 1.88266 5.00666L4.79361 2.09564C5.06545 1.82383 5.06545 1.38315 4.79361 1.11127Z"
          fill="#A0AEC0"
        />
      </svg>
    ),
    kanban: (
      <svg
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill={iconColor}
        class="bi bi-kanban-fill"
      >
        <path d="M2.5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-11zm5 2h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-5 1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3zm9-1h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" />
      </svg>
    ),
    leadMagnet: (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    fill={iconColor}
    className="bi bi-magnet-fill"
  >
    <path d="M4 1a1 1 0 0 1 1 1v5a3 3 0 0 0 6 0V2a1 1 0 1 1 2 0v5a5 5 0 0 1-10 0V2a1 1 0 0 1 1-1z" />
    <path d="M3 13a1 1 0 0 1 1-1h2v2H4a1 1 0 0 1-1-1zm7-1h2a1 1 0 1 1 0 2h-2v-2z" />
  </svg>
),
    aiAgents: (
      <svg
        width="16px"
        height="16px"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill={iconColor}
      >
        <path d="M12 2a1 1 0 0 1 .993.883L13 3v1h2a3 3 0 0 1 2.995 2.824L18 7v10a3 3 0 0 1-2.824 2.995L15 20H9a3 3 0 0 1-2.995-2.824L6 17V7a3 3 0 0 1 2.824-2.995L9 4h2V3a1 1 0 0 1 .883-.993L12 2zm1 5h-2a1 1 0 0 0-.993.883L10 8v1h4V8a1 1 0 0 0-.883-.993L13 7zm-4 4v6h2v-6h-2zm4 0v6h2v-6h-2z" />
      </svg>
    ),
    studentRoadMapOverview: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <rect
          x="1"
          y="1"
          width="22"
          height="22"
          rx="4"
          fill={iconColor}
          fillOpacity="0.1"
        />
        <path
          d="M5 18C5 18 8.5 14 12 14C15.5 14 19 9 19 9"
          stroke={iconColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="5" cy="18" r="1.5" fill={iconColor} />
        <circle cx="12" cy="14" r="1.5" fill={iconColor} />
        <circle cx="19" cy="9" r="1.5" fill={iconColor} />
      </svg>
    ),

    coachingTracking: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill={iconColor}
      >
        <path
          d="M11 2H5C4.44772 2 4 2.44772 4 3V13C4 13.5523 4.44772 14 5 14H11C11.5523 14 12 13.5523 12 13V3C12 2.44772 11.5523 2 11 2Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 4.5H10"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M6 7.5H8"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M6 10L7.2 11.2L10 8.5"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    booksessions: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <rect
          x="1"
          y="1"
          width="22"
          height="22"
          rx="4"
          fill={iconColor}
          fillOpacity="0.1"
        />
        <path
          d="M6 7H18V17C18 18.1 17.1 19 16 19H8C6.9 19 6 18.1 6 17V7Z"
          stroke={iconColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 5V7"
          stroke={iconColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 5V7"
          stroke={iconColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="9" cy="12" r="1.5" fill={iconColor} />
        <circle cx="15" cy="12" r="1.5" fill={iconColor} />
      </svg>
    ),
    aiPrompts: (
      <svg
        width="16px"
        height="16px"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill={iconColor}
      >
        <path d="M12 2C8.13 2 5 5.13 5 9c0 2.38 1.19 4.47 3 5.74V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.87-3.13-7-7-7zM9 19a1 1 0 0 1-1 1H7v1h10v-1h-1a1 1 0 0 1-1-1v-2.27c1.7-1.19 2.82-3.11 2.82-5.73C17.82 5.24 15.28 3 12 3S6.18 5.24 6.18 9c0 2.62 1.12 4.54 2.82 5.73V19zM12 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
      </svg>
    ),
    productPurchase: (
      <svg
        width="16px"
        height="16px"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill={iconColor}
      >
        <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z" />
        <circle cx="9" cy="9" r="1.5" fill={iconColor} opacity="0.7" />
        <path
          d="M20 6.5c0 1.38-1.12 2.5-2.5 2.5S15 7.88 15 6.5 16.12 4 17.5 4 20 5.12 20 6.5z"
          opacity="0.5"
        />
      </svg>
    ),
  };

  return icons[`${name}`];
};
